export const CUSTOMER_TYPES = ["Perusahaan/Fleet", "Perorangan", "Instansi Pemerintah", "Asuransi", "Dealer", "Lainnya"];
export const VEHICLE_TYPES = ["Tractor Head", "Dump Truck", "Cargo Truck", "Light Truck", "Bus", "Pickup", "Box", "Trailer", "Special Vehicle", "Lainnya"];
export const WORK_TYPES = ["Repair Kabin", "Body Repair", "Perbaikan Struktur", "Pengecatan", "Restorasi", "Perbaikan Karoseri", "Modifikasi", "Pembuatan Body/Box", "Interior", "Kelistrikan", "Pekerjaan Kombinasi", "Lainnya"];
export const PRIORITIES = ["Normal", "Urgent", "High Priority"];
export const LOCATIONS = ["Area K3", "Area Customer", "Vendor/Sublet", "Lainnya"];
export const PHOTO_CATEGORIES = ["Tampak Depan", "Tampak Belakang", "Sisi Kanan", "Sisi Kiri", "Kabin/Interior", "Area Kerusakan", "Nomor Polisi", "Nomor Rangka", "Foto Progres", "Foto Hasil Akhir", "Foto Lainnya"];
export const FINAL_PHOTO_CATEGORY = "Foto Hasil Akhir";
export const ROLES = ["Owner", "Manager", "Marketing", "Admin Project", "Kepala Produksi", "Foreman", "Teknisi", "Purchasing", "Warehouse", "Finance", "Security"];

// ---- Unified operational stage (single source of truth) ----
export const STAGES = ["Draft", "Menunggu Persetujuan", "Menunggu Jadwal Masuk", "Siap Masuk",
  "On Production", "Body Repair", "Dempul", "Fabrikasi Rangka", "Pemasangan Body", "Kelistrikan & Aksesoris",
  "Cat", "Finishing", "Ready", "QC", "Unit Out", "Closed"];
export const STAGE_PREORDER = STAGES.slice(1, 4);   // Menunggu Persetujuan, Menunggu Jadwal Masuk, Siap Masuk
export const STAGE_PRODUCTION = STAGES.slice(4, 14); // On Production .. QC (semua jalur)
export const STAGE_IN_WORK = STAGES.slice(4, 12);    // On Production .. Finishing
export const RAP_VIEW = ["Owner", "Manager", "Finance", "Admin Project", "Kepala Produksi", "Foreman", "Purchasing", "Warehouse"];
export const RO_CREATE_STAGE = "On Production";
export const FINAL_PHOTO_STAGE = "Ready";

// Legacy (kept for backward references)
export const STATUSES = ["Draft", "Active", "Hold", "Closed"];
export const RO_STAGES = STAGE_PRODUCTION;
export const DR_STATUSES = ["Draft", "Diajukan", "Disetujui", "Ditolak"];

// ---- Role capabilities ----
export const CAN_CREATE_PROJECT = ["Owner", "Manager", "Admin Project"];
export const CAN_EDIT_PROJECT = ["Owner", "Manager", "Admin Project", "Kepala Produksi"];
export const CAN_MASTER = ["Owner", "Manager", "Admin Project"];
export const CAN_MANAGE_USERS = ["Owner"];
export const CAN_VIEW_AUDIT = ["Owner", "Manager", "Admin Project", "Kepala Produksi"];
export const CAN_SET_PJ = ["Owner", "Manager", "Kepala Produksi"];
export const CAN_STAGE_ADMIN = ["Owner", "Manager", "Admin Project", "Kepala Produksi"];
export const CAN_STAGE_PROD = ["Owner", "Manager", "Kepala Produksi", "Foreman"];
export const CAN_STAGE_BACK = ["Owner", "Manager"];
export const PJ_ROLES = ["Manager", "Kepala Produksi", "Foreman"]; // penanggung jawab dipilih dari peran ini
export const CAN_PREORDER = ["Owner", "Manager", "Admin Project", "Kepala Produksi"];
export const CAN_RO_STATUS = ["Owner", "Manager", "Kepala Produksi", "Foreman"];
export const CAN_APPROVE = ["Owner", "Manager", "Kepala Produksi"];
export const CAN_DR_REOPEN = ["Owner", "Manager"];
export const CAN_DR_CREATE = ["Owner", "Manager", "Kepala Produksi", "Foreman", "Teknisi"];
export const PROD_VIEW_ROLES = ["Owner", "Manager", "Kepala Produksi", "Admin Project", "Foreman", "Teknisi"];
export const DR_MENU_ROLES = ["Owner", "Manager", "Kepala Produksi", "Foreman", "Teknisi"];

// ---- Costing module (Estimasi / RAB / HPP) ----
export const FEATURE_FLAGS = { preOrder: false, repairOrder: false };
export const ESTIMATE_VIEW = ["Owner", "Manager", "Finance", "Admin Project", "Marketing"];
export const ESTIMATE_MANAGE = ["Owner", "Manager", "Admin Project", "Marketing"];
export const ESTIMATE_APPROVE = ["Owner", "Manager"];
export const RAB_VIEW = ["Owner", "Manager", "Finance", "Admin Project", "Kepala Produksi", "Foreman", "Teknisi"];
export const RAB_MANAGE = ["Owner", "Manager", "Admin Project"];
export const RAB_ACTUAL = ["Owner", "Manager", "Admin Project", "Kepala Produksi", "Foreman"];
export const RAB_MONEY = ["Owner", "Manager", "Finance", "Admin Project"];
export const HPP_VIEW = ["Owner", "Manager", "Finance", "Kepala Produksi"];
export const MONEY_ROLES = ["Owner", "Manager", "Finance"];
export const ESTIMATE_STATUSES = ["Draft", "Diajukan", "Disetujui", "Ditolak", "Terkirim"];
export const MATERIAL_CATEGORIES = ["Besi/Plat", "Aluminium", "Stainless", "Kayu/Multipleks", "Fiberglass", "Cat & Thinner", "Dempul", "Kelistrikan", "Lampu", "Interior", "Aksesori", "Baut & Consumable", "Ban/Komponen Kendaraan", "Vendor/Subkon", "Lainnya"];
export const ESTIMATE_CATEGORIES = ["Jasa Pengerjaan", "Bahan/Material", "Sparepart", "Vendor/Subkon", "Transportasi", "Biaya Lainnya"];

// ---- Material Usage (HPP Material Sheet) ----
export const MATERIAL_USAGE_VIEW = ["Owner", "Manager", "Finance", "Admin Project", "Kepala Produksi", "Foreman", "Teknisi"];
export const MATERIAL_USAGE_RECORD = ["Owner", "Manager", "Admin Project", "Kepala Produksi", "Foreman"];
export const MATERIAL_USAGE_MONEY = ["Owner", "Manager", "Finance", "Admin Project"];
// ---- Harga Deal (Project & SPK/RO) ----
export const DEAL_VIEW = ["Owner", "Manager", "Finance", "Marketing", "Admin Project"];
export const PROFIT_VIEW = ["Owner", "Manager", "Finance"];
export const TAX_MODES = ["Termasuk PPN", "Belum Termasuk PPN", "Tanpa PPN"];
export const MATERIAL_SOURCES = ["Warehouse", "Pembelian Langsung", "Supplier"];
